import { SSRGlobal } from "../qecomps/Context"

export default () => {
    let z = SSRGlobal()
    return {
        "en":
            [
                null,
                (props) => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>
                    1- This product has a {props.days.toLocaleString(z.lang.region)} days guarantee of <span style={{ backgroundColor: "#00c82f0000" }}> &nbsp;correct operation</span>.
                    <br />
                    <br />
                    2- If during the warranty period you
                    faced <span style={{ backgroundColor: "#f692180000" }}>&nbsp;any problem&nbsp;</span> in the product's operation, <span style={{ backgroundColor: "#00c82f00" }}>
                        your deposit will be returned to your account.
                    </span>
                    <br />
                    <br />
                    3- Please note that <span style={{ backgroundColor: "#00c82f00" }}>Automated Trading Robots</span> and <span
                        style={{ backgroundColor: "#00c82f00" }}>Copy Trading systems</span> whose signals have been issued from our system, whose correct operation is
                    related to profitability, and if they are <span style={{ backgroundColor: "#f6921800" }}>unprofitable during the warranty period</span>, <span
                        style={{ backgroundColor: "#00c82f00" }}>the all of your deposit fee to us for this product will be returned.</span>
                    <br />
                    <br />
                    4- The guarantee of the other <span style={{ backgroundColor: "#00c82f00" }}>tools and softwares such as DLLs, scripts, scrappers, data sources</span>&nbsp;
                    and everything other than the paragraph '3' is related to the exact &nbsp;
                    <span style={{ backgroundColor: "#00c82f00" }}>capability and accuracy of the operation</span> described in its documentation and has <span
                        style={{ backgroundColor: "#f6921800" }}>nothing to do</span> with the <span style={{ backgroundColor: "#f6921800" }}>way of use and the profit or loss of your trading system or business</span>.
                    <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
                    <br />
                    <br />
                </div>,
                //2:
                (props) => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>
                    1- This product has a {props.days.toLocaleString(z.lang.region)} days guarantee of <span style={{ backgroundColor: "#00c82f00" }}> &nbsp;correct operation</span>.
                    <br />
                    <br />
                    2- During the warranty period, if you encounter a <span style={{ backgroundColor: "#f6921800" }}>&nbsp; serious and unsolvable technical issue&nbsp;</span> regarding the service, <span style={{ backgroundColor: "#00c82f00" }}>
                        the payment amount for this service will be refunded to your account.
                    </span>
                    <br />
                    <br />
                    3- Please note that <span style={{ backgroundColor: "#00c82f00" }}>Automated Trading Robots</span> and <span
                        style={{ backgroundColor: "#00c82f00" }}>Copy Trading systems</span> whose signals have been issued from our system, whose correct operation is
                    related to profitability, and if they are <span style={{ backgroundColor: "#f6921800" }}>unprofitable during the warranty period</span>, <span
                        style={{ backgroundColor: "#00c82f00" }}>the all of your deposit fee to us for this product will be returned.</span>
                    <br />
                    <br />
                    4- The guarantee of the other <span style={{ backgroundColor: "#00c82f00" }}>tools and softwares such as DLLs, scripts, scrappers, data sources</span>&nbsp;
                    and everything other than the paragraph '3' is related to the exact &nbsp;
                    <span style={{ backgroundColor: "#00c82f00" }}>capability and accuracy of the operation</span> described in its documentation and has <span
                        style={{ backgroundColor: "#f6921800" }}>nothing to do</span> with the <span style={{ backgroundColor: "#f6921800" }}>way of use and the profit or loss of your trading system or business</span>.
                    <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
                    <br />
                    <br />
                </div>,
                //3:
                props => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>
                    <span style={{ backgroundColor: "#00c82f00" }}> 1- This product comes with a {props.days.toLocaleString(z.lang.region)} day consultation and guidance guarantee.</span>
                    <br />
                    <br />

                    <span style={{ backgroundColor: "#00c82f00" }}>
                        2- During the guarantee period, guidance is provided by relevant specialists in the field of services provided, and
                        all questions and ambiguities related to it will be resolved through direct contact with the specialist in the relevant field.
                    </span>


                    <br />
                    <br />
                    <span style={{ backgroundColor: "#00c82f00" }}> 3- The consultation guarantee includes guidance and clarification in the service area
                    </span>


                    <span style={{ backgroundColor: "#f6921800" }}>
                        and its implementation in other
                        miscellaneous areas is not a criterion
                    </span>


                    <span style={{ backgroundColor: "#00c82f00" }}>
                        however, the support will help the buyer as much as possible to solve his problem.
                    </span>

                    <br />
                    <br />
                    <span style={{ backgroundColor: "#f6921800" }}>
                        4- The guarantee does not include additional coding, carrying out miscellaneous projects, or participating in exam sessions
                    </span>
                    <br />
                    <br />


                    5- The guarantee is carried out through communication via collective communication tools such as
                    &nbsp;
                    <span style={{ backgroundColor: "#00c82f00" }}>Telegram</span>
                    ,
                    &nbsp;
                    <span style={{ backgroundColor: "#00c82f00" }}>Google Meet</span> &nbsp;
                    and
                    &nbsp;
                    <span style={{ backgroundColor: "#00c82f00" }}>Skype</span> &nbsp;
                    it is also worth mentioning that
                    installing the
                    &nbsp;
                    <span style={{ backgroundColor: "#00c82f00" }}>AnyDesk</span> &nbsp;
                    application on the applicant's system is necessary if the specialist deems it appropriate.

                    <br />
                    <br />
                    <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
                </div>


            ],
        "fa":
            [
                null,
                (props) => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>
                    ۱- این محصول دارای {props.days.toLocaleString(z.lang.region)} روز گارانتی <span style={{ backgroundColor: "#00c82f00" }}> &nbsp;عملکرد صحیح میباشد</span>.

                    <br />
                    <br />
                    ۲- اگر در طول دوره گارانتی <span style={{ backgroundColor: "#f6921800" }}>&nbsp;با هر گونه مشکل فنی&nbsp;</span> در خصوص سرویس مواجه شوید، <span style={{ backgroundColor: "#00c82f00" }}>
                        مبلغ پرداختی برای این سرویس به حساب شما بازگردانده می‌شود.
                    </span>

                    <br />
                    <br />
                    ۳- لطفا توجه داشته باشید که  <span style={{ backgroundColor: "#00c82f00" }}>ابزارهای تحلیلی و ربات های استراتژیست</span> و <span
                        style={{ backgroundColor: "#00c82f00" }}>سیستم های کپی کننده معاملاتی </span> در صورتی که سیگنال های آن از سمت سیستم ما صادر شده باشد
                    گارانتی سود آوری دارند و  <span style={{ backgroundColor: "#f6921800" }}>در صورتی که در زمان تعیین شده سود آور نباشند </span>, <span
                        style={{ backgroundColor: "#00c82f00" }}>تمامی واریزی شما بابت این سرویس به حساب شما بازگردانده میشود.</span>
                    <br />
                    <br />
                    ۴- گارانتی دیگر سرویس ها همانند  <span style={{ backgroundColor: "#00c82f00" }}>ابزارها و نرم افزارهایی همانند ای پی آی ها، کتابخانه های اسمبلی و ابزارهای آنالیز و غیره</span>&nbsp;
                    با ملاک عملکرد صحیح  &nbsp;
                    <span style={{ backgroundColor: "#00c82f00" }}>مطابق با عملکرد صحیح مطابق با مواردی که در متن یا ویدیو های</span>
                    توصیف شده در اکسپلور سرویس باشند گارانتی میگردند
                    &nbsp;
                    <span style={{ backgroundColor: "#f6921800" }}>و در نهایت سود آوری ابزارهایی که به بیزینس مدل شما و نحوه به کار گیری ابزارها بستگی داشته باشد شامل گارانتی نمیباشند.</span>
                    <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
                    <br />
                    <br />
                </div>,
                //2:
                (props) => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>
                    ۱- این محصول دارای {props.days.toLocaleString(z.lang.region)} روز گارانتی <span style={{ backgroundColor: "#00c82f00" }}> &nbsp;عملکرد صحیح میباشد</span>.

                    <br />
                    <br />
                    ۲- اگر در طول دوره گارانتی <span style={{ backgroundColor: "#f6921800" }}>&nbsp; مشکل فنی جدی و غیرقابل حل&nbsp;</span> در خصوص سرویس مواجه شوید، <span style={{ backgroundColor: "#00c82f00" }}>
                        مبلغ پرداختی برای این سرویس به حساب شما بازگردانده می‌شود.
                    </span>

                    <br />
                    <br />
                    ۳- لطفا توجه داشته باشید که  <span style={{ backgroundColor: "#00c82f00" }}>ابزارهای تحلیلی و ربات های استراتژیست</span> و <span
                        style={{ backgroundColor: "#00c82f00" }}>سیستم های کپی کننده معاملاتی </span> در صورتی که سیگنال های آن از سمت سیستم ما صادر شده باشد
                    گارانتی سود آوری دارند و  <span style={{ backgroundColor: "#f6921800" }}>در صورتی که در زمان تعیین شده سود آور نباشند </span>, <span
                        style={{ backgroundColor: "#00c82f00" }}>تمامی واریزی شما بابت این سرویس به حساب شما بازگردانده میشود.</span>
                    <br />
                    <br />
                    ۴- گارانتی دیگر سرویس ها همانند  <span style={{ backgroundColor: "#00c82f00" }}>ابزارها و نرم افزارهایی همانند ای پی آی ها، کتابخانه های اسمبلی و ابزارهای آنالیز و غیره</span>&nbsp;
                    با ملاک عملکرد صحیح  &nbsp;
                    <span style={{ backgroundColor: "#00c82f00" }}>مطابق با عملکرد صحیح مطابق با مواردی که در متن یا ویدیو های</span>
                    توصیف شده در اکسپلور سرویس باشند گارانتی میگردند
                    &nbsp;
                    <span style={{ backgroundColor: "#f6921800" }}>و در نهایت سود آوری ابزارهایی که به بیزینس مدل شما و نحوه به کار گیری ابزارها بستگی داشته باشد شامل گارانتی نمیباشند.</span>
                    <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
                    <br />
                    <br />
                </div>,
                //3:
                (props) => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>
                    <span style={{ backgroundColor: "#00c82f00" }}> ۱- این محصول دارای {props.days.toLocaleString(z.lang.region)}  روز گارانتی مشاوره و راهنمایی است.</span>
                    <br />
                    <br />

                    <span style={{ backgroundColor: "#00c82f00" }}>
                        ۲- در طول دوره‌ی گارانتی در حوزه‌ی خدمات ارائه شده راهنمایی توسط متخصصین مربوطه انجام میگردد و
                        تمامی سوالات و ابهامات مربوطه به واسطه‌ی ارتباط مستقیم با متخصص حوزه‌ی مربوطه برطرف خواهد شد.
                    </span>
                    &nbsp;

                    <br />
                    <br />
                    <span style={{ backgroundColor: "#00c82f00" }}> ۳- گارانتی مشاوره شامل راهنمایی و رفع ابهام در حوزه‌ی سرویس می‌باشد
                    </span>
                    &nbsp;

                    <span style={{ backgroundColor: "#f6921800" }}>
                        و اجرای آن در در حوزه‌های
                        متفرقه دیگر ملاک نیست
                    </span>
                    &nbsp;

                    <span style={{ backgroundColor: "#00c82f00" }}>
                        اما با این حال پشتیبان، به خریدار تا حد امکان برای رفع مشکل او کمک خواهد کرد.
                    </span>

                    <br />
                    <br />
                    <span style={{ backgroundColor: "#f6921800" }}>
                        ۴- گارانتی شامل کدنویسی اضافه، انجام پروژه‌های متفرقه و یا شرکت در جلسات امتحانی نمی‌باشد
                    </span>
                    <br />
                    <br />


                    ۵- گارانتی به وسیله ارتباط از طریق ابزارهای ارتباط جمعی همانند
                    &nbsp;
                    <span style={{ backgroundColor: "#00c82f00" }}>تلگرام</span> &nbsp;
                    ،
                    <span style={{ backgroundColor: "#00c82f00" }}>گوگل میت</span> &nbsp;
                    و
                    &nbsp;
                    <span style={{ backgroundColor: "#00c82f00" }}>اسکایپ</span> &nbsp;
                    انجام میگردد همچنین شایان ذکر است که
                    نصب برنامه‌ی
                    &nbsp;
                    <span style={{ backgroundColor: "#00c82f00" }}>انی دسک</span> &nbsp;

                    در صورت صلاح دید متخصص برروی سیستم متقاضی ضروری است.

                    <br />
                    <br />
                    <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
                </div>
            ],
        "ar": [
            null,
            (props) => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>

                ۱- هذا المنتج مغطى بضمان لمدة {props.days.toLocaleString(z.lang.region)} يومًا ل<span style={{ backgroundColor: "#00c82f00" }}> &nbsp;العمل الصحيح</span>.
                <br />
                <br />
                ۲- إذا واجهت <span style={{ backgroundColor: "#f6921800" }}>&nbsp;أي مشكلة&nbsp;</span> في الخدمة أثناء فترة الضمان، <span style={{ backgroundColor: "#00c82f00" }}>
                    سيتم استرداد مبلغ الدفع الخاص بك لهذه الخدمة إلى حسابك.
                </span>
                <br />
                <br />

                ۳- يُرجى ملاحظة أن <span style={{ backgroundColor: "#00c82f00" }}>أدوات التحليل وروبوتات الاستراتيجيات</span> وكذلك <span
                    style={{ backgroundColor: "#00c82f00" }}>أنظمة نسخ التداول</span> التي تولد إشاراتها من نظامنا، تضمن الربحية. ومع ذلك، <span style={{ backgroundColor: "#f6921800" }}>إذا لم تحقق أرباحًا خلال الفترة المحددة،</span> <span
                        style={{ backgroundColor: "#00c82f00" }}>سيتم استرداد جميع مدفوعاتك لهذه الخدمة إلى حسابك.</span>
                <br />
                <br />

                ۴- الضمانات الأخرى للخدمات مثل <span style={{ backgroundColor: "#00c82f00" }}>الأدوات والبرامج مثل واجهات برمجة التطبيقات (APIs)، مكتبات التجميع، وأدوات التحليل، وما إلى ذلك</span> تكون مضمونة وفقًا لمعايير الأداء الصحيحة. يجب أن تتوافق مع المعايير الصحيحة الموضحة في النص أو الفيديوهات في خدمة الاستكشاف.
                وفي النهاية، <span style={{ backgroundColor: "#f6921800" }}>لا يشمل الضمان الربحية للأدوات التي تعتمد على نموذج الأعمال الخاص بك وكيفية استخدام الأدوات.</span>

                <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
                <br />
                <br />
            </div>,
            //2:
            (props) => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>

                ۱- هذا المنتج مغطى بضمان لمدة {props.days.toLocaleString(z.lang.region)} يومًا ل<span style={{ backgroundColor: "#00c82f00" }}> &nbsp;العمل الصحيح</span>.
                <br />
                <br />
                ۲- خلال فترة الضمان، إذا واجهتك مشكلة تقنية <span style={{ backgroundColor: "#f6921800" }}>  خطيرة وغير قابلة للحل </span> بخصوص الخدمة، <span style={{ backgroundColor: "#00c82f00" }}>
                    سيتم استرداد مبلغ الدفع لهذه الخدمة إلى حسابك.
                </span>
                <br />
                <br />

                ۳- يُرجى ملاحظة أن <span style={{ backgroundColor: "#00c82f00" }}>أدوات التحليل وروبوتات الاستراتيجيات</span> وكذلك <span
                    style={{ backgroundColor: "#00c82f00" }}>أنظمة نسخ التداول</span> التي تولد إشاراتها من نظامنا، تضمن الربحية. ومع ذلك، <span style={{ backgroundColor: "#f6921800" }}>إذا لم تحقق أرباحًا خلال الفترة المحددة،</span> <span
                        style={{ backgroundColor: "#00c82f00" }}>سيتم استرداد جميع مدفوعاتك لهذه الخدمة إلى حسابك.</span>
                <br />
                <br />

                ۴- الضمانات الأخرى للخدمات مثل <span style={{ backgroundColor: "#00c82f00" }}>الأدوات والبرامج مثل واجهات برمجة التطبيقات (APIs)، مكتبات التجميع، وأدوات التحليل، وما إلى ذلك</span> تكون مضمونة وفقًا لمعايير الأداء الصحيحة. يجب أن تتوافق مع المعايير الصحيحة الموضحة في النص أو الفيديوهات في خدمة الاستكشاف.
                وفي النهاية، <span style={{ backgroundColor: "#f6921800" }}>لا يشمل الضمان الربحية للأدوات التي تعتمد على نموذج الأعمال الخاص بك وكيفية استخدام الأدوات.</span>

                <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
                <br />
                <br />
            </div>,
            //3:
            props => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>
                <span style={{ backgroundColor: "#00c82f00" }}> ۱- هذا المنتج يأتي مع ضمان استشارة وتوجيه لمدة {props.days.toLocaleString(z.lang.region)} يوم.</span>
                <br />
                <br />

                <span style={{ backgroundColor: "#00c82f00" }}>
                    ۲- خلال فترة الضمان، يتم تقديم التوجيه من قبل المتخصصين ذوي الصلة في مجال الخدمات المقدمة، و
                    سيتم حل جميع الأسئلة والغموض المتعلقة بها من خلال الاتصال المباشر مع المتخصص في المجال ذي الصلة.
                </span>


                <br />
                <br />
                <span style={{ backgroundColor: "#00c82f00" }}> ۳- يشمل ضمان الاستشارة التوجيه والتوضيح في مجال الخدمة
                </span>


                <span style={{ backgroundColor: "#f6921800" }}>
                    وتنفيذه في غيرها
                    من المجالات المتنوعة ليس معيارًا
                </span>


                <span style={{ backgroundColor: "#00c82f00" }}>
                    ومع ذلك، سيساعد الدعم المشتري قدر الإمكان لحل مشكلته.
                </span>

                <br />
                <br />
                <span style={{ backgroundColor: "#f6921800" }}>
                    ۴- الضمان لا يشمل البرمجة الإضافية، أو تنفيذ المشاريع المتنوعة، أو المشاركة في جلسات الامتحان
                </span>
                <br />
                <br />


                ۵- يتم تنفيذ الضمان من خلال الاتصال عبر أدوات الاتصال الجماعي مثل
                <span style={{ backgroundColor: "#00c82f00" }}>تليجرام</span>
                ،
                <span style={{ backgroundColor: "#00c82f00" }}>جوجل ميت</span>
                و
                <span style={{ backgroundColor: "#00c82f00" }}>سكايب</span>
                من الجدير بالذكر أيضًا أن
                تثبيت تطبيق
                <span style={{ backgroundColor: "#00c82f00" }}>أي ديسك</span>
                على نظام المتقدم ضروري إذا رأى المتخصص أنه مناسب.

                <br />
                <br />
                <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
            </div>

        ],
        "de": [
            null,
            (props) => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>

                1- Dieses Produkt ist durch eine {props.days.toLocaleString(z.lang.region)}-Tage-Garantie für <span style={{ backgroundColor: "#00c82f00" }}> &nbsp;korrekte Funktion</span> abgedeckt.
                <br />
                <br />
                2- Wenn Sie <span style={{ backgroundColor: "#f6921800" }}>&nbsp;irgendwelche Probleme&nbsp;</span> mit dem Service während der Garantiezeit haben, <span style={{ backgroundColor: "#00c82f00" }}>
                    wird Ihre Zahlung für diesen Service auf Ihr Konto zurückerstattet.
                </span>

                <br />
                <br />

                3- Bitte beachten Sie, dass <span style={{ backgroundColor: "#00c82f00" }}>analytische Werkzeuge und Strategie-Roboter</span> sowie <span
                    style={{ backgroundColor: "#00c82f00" }}>Kopierhandelssysteme</span>, die ihre Signale von unserem System generieren, Rentabilität garantieren. Allerdings, <span style={{ backgroundColor: "#f6921800" }}>wenn sie innerhalb der angegebenen Zeit keine Gewinne erzielen,</span> <span
                        style={{ backgroundColor: "#00c82f00" }}>werden alle Zahlungen für diesen Service auf Ihr Konto zurückerstattet.</span>

                <br />
                <br />

                4- Andere Dienste wie <span style={{ backgroundColor: "#00c82f00" }}>Tools und Software wie APIs, Assembly-Bibliotheken und Analysetools usw.</span> werden gemäß den richtigen Leistungskriterien garantiert. Sie sollten den korrekten Leistungskriterien entsprechen, die im Text oder in den Videos des Explore-Dienstes beschrieben sind.
                <span style={{ backgroundColor: "#f6921800" }}>Die Rentabilität von Tools, die von Ihrem Geschäftsmodell und der Art und Weise, wie die Tools verwendet werden, abhängen, ist nicht durch die Garantie abgedeckt.</span>


                <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
                <br />
                <br />
            </div>,
            //2:
            (props) => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>

                1- Dieses Produkt ist durch eine {props.days.toLocaleString(z.lang.region)}-Tage-Garantie für <span style={{ backgroundColor: "#00c82f00" }}> &nbsp;korrekte Funktion</span> abgedeckt.
                <br />
                <br />
                2- Während der Garantiezeit, wenn Sie auf ein <span style={{ backgroundColor: "#f6921800" }}>  schwerwiegendes und unlösbares technisches Problem </span> im Zusammenhang mit dem Service stoßen, <span style={{ backgroundColor: "#00c82f00" }}>
                    wird der Zahlungsbetrag für diesen Service auf Ihr Konto zurückerstattet.
                </span>

                <br />
                <br />

                3- Bitte beachten Sie, dass <span style={{ backgroundColor: "#00c82f00" }}>analytische Werkzeuge und Strategie-Roboter</span> sowie <span
                    style={{ backgroundColor: "#00c82f00" }}>Kopierhandelssysteme</span>, die ihre Signale von unserem System generieren, Rentabilität garantieren. Allerdings, <span style={{ backgroundColor: "#f6921800" }}>wenn sie innerhalb der angegebenen Zeit keine Gewinne erzielen,</span> <span
                        style={{ backgroundColor: "#00c82f00" }}>werden alle Zahlungen für diesen Service auf Ihr Konto zurückerstattet.</span>

                <br />
                <br />

                4- Andere Dienste wie <span style={{ backgroundColor: "#00c82f00" }}>Tools und Software wie APIs, Assembly-Bibliotheken und Analysetools usw.</span> werden gemäß den richtigen Leistungskriterien garantiert. Sie sollten den korrekten Leistungskriterien entsprechen, die im Text oder in den Videos des Explore-Dienstes beschrieben sind.
                <span style={{ backgroundColor: "#f6921800" }}>Die Rentabilität von Tools, die von Ihrem Geschäftsmodell und der Art und Weise, wie die Tools verwendet werden, abhängen, ist nicht durch die Garantie abgedeckt.</span>


                <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
                <br />
                <br />
            </div>,
            //3:
            props => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>
                <span style={{ backgroundColor: "#00c82f00" }}> 1- Dieses Produkt kommt mit einer {props.days.toLocaleString(z.lang.region)} Tage Beratungs- und Anleitungsgarantie.</span>
                <br />
                <br />

                <span style={{ backgroundColor: "#00c82f00" }}>
                    2- Während der Garantiezeit wird die Beratung von relevanten Spezialisten im Bereich der erbrachten Dienstleistungen durchgeführt, und
                    alle Fragen und Unklarheiten dazu werden durch direkten Kontakt mit dem Spezialisten im relevanten Bereich gelöst.
                </span>


                <br />
                <br />
                <span style={{ backgroundColor: "#00c82f00" }}> 3- Die Beratungsgarantie beinhaltet Beratung und Klärung im Dienstleistungsbereich
                </span>


                <span style={{ backgroundColor: "#f6921800" }}>
                    und deren Umsetzung in anderen
                    verschiedenen Bereichen ist kein Kriterium
                </span>


                <span style={{ backgroundColor: "#00c82f00" }}>
                    jedoch wird der Support dem Käufer so weit wie möglich helfen, sein Problem zu lösen.
                </span>

                <br />
                <br />
                <span style={{ backgroundColor: "#f6921800" }}>
                    4- Die Garantie beinhaltet keine zusätzliche Programmierung, Durchführung von verschiedenen Projekten oder Teilnahme an Prüfungssitzungen
                </span>
                <br />
                <br />


                5- Die Garantie wird durch Kommunikation über kollektive Kommunikationswerkzeuge wie
                <span style={{ backgroundColor: "#00c82f00" }}>Telegram</span>
                ,
                <span style={{ backgroundColor: "#00c82f00" }}>Google Meet</span>
                und
                <span style={{ backgroundColor: "#00c82f00" }}>Skype</span>
                durchgeführt es ist auch erwähnenswert, dass
                die Installation der
                <span style={{ backgroundColor: "#00c82f00" }}>AnyDesk</span>
                Anwendung auf dem System des Antragstellers notwendig ist, wenn der Spezialist dies für angemessen hält.

                <br />
                <br />
                <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
            </div>
        ],
        "es": [
            null,
            (props) => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>

                1- Este producto está cubierto por una garantía de {props.days.toLocaleString(z.lang.region)} días para <span style={{ backgroundColor: "#00c82f00" }}> &nbsp;funcionamiento correcto</span>.
                <br />
                <br />
                2- Si experimentas <span style={{ backgroundColor: "#f6921800" }}>&nbsp;algún problema&nbsp;</span> con el servicio durante el período de garantía, <span style={{ backgroundColor: "#00c82f00" }}>
                    se reembolsará tu pago por este servicio a tu cuenta.
                </span>

                <br />
                <br />

                3-Por favor, tenga en cuenta que <span style={{ backgroundColor: "#00c82f00" }}>las herramientas analíticas y los robots estrategas</span> y <span
                    style={{ backgroundColor: "#00c82f00" }}>los sistemas de copia de operaciones</span> garantizan la rentabilidad si sus señales son generadas por nuestro sistema. Sin embargo, si no son rentables dentro del tiempo especificado, <span style={{ backgroundColor: "#f6921800" }}>todos sus depósitos para este servicio serán reembolsados a su cuenta.</span>
                <br />
                <br />

                4- Otros servicios como <span style={{ backgroundColor: "#00c82f00" }}>herramientas y software como APIs, bibliotecas de ensamblaje, herramientas de análisis, etc.</span> están garantizados según los criterios de rendimiento adecuados. Deben cumplir con los criterios de rendimiento correctos descritos en el texto o videos del servicio Explore.
                <span style={{ backgroundColor: "#f6921800" }}>Finalmente, la rentabilidad de las herramientas que dependen de su modelo de negocio y de cómo se utilizan las herramientas no está cubierta por la garantía.</span>


                <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
                <br />
                <br />
            </div>,
            //2:
            (props) => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>

                1- Este producto está cubierto por una garantía de {props.days.toLocaleString(z.lang.region)} días para <span style={{ backgroundColor: "#00c82f00" }}> &nbsp;funcionamiento correcto</span>.
                <br />
                <br />
                2- Durante el período de garantía, si te encuentras con un problema técnico <span style={{ backgroundColor: "#f6921800" }}>  grave e insoluble </span> con respecto al servicio, <span style={{ backgroundColor: "#00c82f00" }}>
                    se reembolsará el monto del pago por este servicio a tu cuenta.
                </span>

                <br />
                <br />

                3-Por favor, tenga en cuenta que <span style={{ backgroundColor: "#00c82f00" }}>las herramientas analíticas y los robots estrategas</span> y <span
                    style={{ backgroundColor: "#00c82f00" }}>los sistemas de copia de operaciones</span> garantizan la rentabilidad si sus señales son generadas por nuestro sistema. Sin embargo, si no son rentables dentro del tiempo especificado, <span style={{ backgroundColor: "#f6921800" }}>todos sus depósitos para este servicio serán reembolsados a su cuenta.</span>
                <br />
                <br />

                4- Otros servicios como <span style={{ backgroundColor: "#00c82f00" }}>herramientas y software como APIs, bibliotecas de ensamblaje, herramientas de análisis, etc.</span> están garantizados según los criterios de rendimiento adecuados. Deben cumplir con los criterios de rendimiento correctos descritos en el texto o videos del servicio Explore.
                <span style={{ backgroundColor: "#f6921800" }}>Finalmente, la rentabilidad de las herramientas que dependen de su modelo de negocio y de cómo se utilizan las herramientas no está cubierta por la garantía.</span>


                <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
                <br />
                <br />
            </div>,
            //3:
            props => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>
                <span style={{ backgroundColor: "#00c82f00" }}> 1- Este producto viene con una garantía de consulta y orientación de {props.days.toLocaleString(z.lang.region)} días.</span>
                <br />
                <br />

                <span style={{ backgroundColor: "#00c82f00" }}>
                    2- Durante el período de garantía, se proporciona orientación por parte de especialistas relevantes en el campo de los servicios prestados, y
                    todas las preguntas y ambigüedades relacionadas con ello se resolverán a través del contacto directo con el especialista en el campo relevante.
                </span>


                <br />
                <br />
                <span style={{ backgroundColor: "#00c82f00" }}> 3- La garantía de consulta incluye orientación y aclaración en el área de servicio
                </span>


                <span style={{ backgroundColor: "#f6921800" }}>
                    y su implementación en otras
                    áreas diversas no es un criterio
                </span>


                <span style={{ backgroundColor: "#00c82f00" }}>
                    sin embargo, el soporte ayudará al comprador tanto como sea posible para resolver su problema.
                </span>

                <br />
                <br />
                <span style={{ backgroundColor: "#f6921800" }}>
                    4- La garantía no incluye codificación adicional, realización de proyectos diversos o participación en sesiones de examen
                </span>
                <br />
                <br />


                5- La garantía se lleva a cabo a través de la comunicación a través de herramientas de comunicación colectiva como
                <span style={{ backgroundColor: "#00c82f00" }}>Telegram</span>
                ,
                <span style={{ backgroundColor: "#00c82f00" }}>Google Meet</span>
                y
                <span style={{ backgroundColor: "#00c82f00" }}>Skype</span>
                también vale la pena mencionar que
                la instalación de la aplicación
                <span style={{ backgroundColor: "#00c82f00" }}>AnyDesk</span>
                en el sistema del solicitante es necesario si el especialista lo considera apropiado.

                <br />
                <br />
                <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
            </div>

        ],
        "fr": [
            null,
            //1:
            (props) => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>

                1- Ce produit est couvert par une garantie de {props.days.toLocaleString(z.lang.region)} jours pour <span style={{ backgroundColor: "#00c82f00" }}> &nbsp;un fonctionnement correct</span>.
                <br />
                <br />
                2- Si vous rencontrez <span style={{ backgroundColor: "#f6921800" }}>&nbsp;le moindre problème&nbsp;</span> avec le service pendant la période de garantie, <span style={{ backgroundColor: "#00c82f00" }}>
                    votre paiement pour ce service sera remboursé sur votre compte.
                </span>

                <br />
                <br />

                3-Veuillez noter que les <span style={{ backgroundColor: "#00c82f00" }}>outils d'analyse et les robots stratégiques</span> ainsi que les <span
                    style={{ backgroundColor: "#00c82f00" }}>systèmes de copie de transactions</span> garantissent la rentabilité si leurs signaux sont générés par notre système. Cependant, s'ils ne sont pas rentables dans le délai spécifié, <span style={{ backgroundColor: "#f6921800" }}>tous vos dépôts pour ce service seront remboursés sur votre compte.</span>
                <br />
                <br />
                4- D'autres services tels que <span style={{ backgroundColor: "#00c82f00" }}>outils et logiciels tels que les APIs, les bibliothèques d'assemblage, les outils d'analyse, etc.</span> sont garantis selon les critères de performance appropriés. Ils doivent être conformes aux critères de performance corrects décrits dans le texte ou les vidéos du service Explore.
                <span style={{ backgroundColor: "#f6921800" }}>Enfin, la rentabilité des outils qui dépendent de votre modèle commercial et de la manière dont les outils sont utilisés n'est pas couverte par la garantie.</span>


                <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
                <br />
                <br />
            </div>,
            //2:
            (props) => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>

                1- Ce produit est couvert par une garantie de {props.days.toLocaleString(z.lang.region)} jours pour <span style={{ backgroundColor: "#00c82f00" }}> &nbsp;un fonctionnement correct</span>.
                <br />
                <br />
                2- Pendant la période de garantie, si vous rencontrez un problème technique <span style={{ backgroundColor: "#f6921800" }}>&nbsp; grave et insoluble&nbsp;</span> concernant le service, <span style={{ backgroundColor: "#00c82f00" }}>
                    le montant du paiement pour ce service sera remboursé sur votre compte.
                </span>

                <br />
                <br />

                3-Veuillez noter que les <span style={{ backgroundColor: "#00c82f00" }}>outils d'analyse et les robots stratégiques</span> ainsi que les <span
                    style={{ backgroundColor: "#00c82f00" }}>systèmes de copie de transactions</span> garantissent la rentabilité si leurs signaux sont générés par notre système. Cependant, s'ils ne sont pas rentables dans le délai spécifié, <span style={{ backgroundColor: "#f6921800" }}>tous vos dépôts pour ce service seront remboursés sur votre compte.</span>
                <br />
                <br />
                4- D'autres services tels que <span style={{ backgroundColor: "#00c82f00" }}>outils et logiciels tels que les APIs, les bibliothèques d'assemblage, les outils d'analyse, etc.</span> sont garantis selon les critères de performance appropriés. Ils doivent être conformes aux critères de performance corrects décrits dans le texte ou les vidéos du service Explore.
                <span style={{ backgroundColor: "#f6921800" }}>Enfin, la rentabilité des outils qui dépendent de votre modèle commercial et de la manière dont les outils sont utilisés n'est pas couverte par la garantie.</span>


                <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
                <br />
                <br />
            </div>,
            //3:
            props => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>
                <span style={{ backgroundColor: "#00c82f00" }}> 1- Ce produit est livré avec une garantie de consultation et d'orientation de {props.days.toLocaleString(z.lang.region)} jours.</span>
                <br />
                <br />

                <span style={{ backgroundColor: "#00c82f00" }}>
                    2- Pendant la période de garantie, des conseils sont fournis par des spécialistes pertinents dans le domaine des services fournis, et
                    toutes les questions et ambiguïtés y afférentes seront résolues par un contact direct avec le spécialiste dans le domaine concerné.
                </span>


                <br />
                <br />
                <span style={{ backgroundColor: "#00c82f00" }}> 3- La garantie de consultation comprend des conseils et des éclaircissements dans le domaine du service
                </span>


                <span style={{ backgroundColor: "#f6921800" }}>
                    et sa mise en œuvre dans d'autres
                    domaines divers n'est pas un critère
                </span>


                <span style={{ backgroundColor: "#00c82f00" }}>
                    cependant, le support aidera l'acheteur autant que possible pour résoudre son problème.
                </span>

                <br />
                <br />
                <span style={{ backgroundColor: "#f6921800" }}>
                    4- La garantie ne comprend pas la programmation supplémentaire, la réalisation de projets divers ou la participation à des sessions d'examen
                </span>
                <br />
                <br />


                5- La garantie est réalisée par communication via des outils de communication collective tels que
                <span style={{ backgroundColor: "#00c82f00" }}>Telegram</span>
                ,
                <span style={{ backgroundColor: "#00c82f00" }}>Google Meet</span>
                et
                <span style={{ backgroundColor: "#00c82f00" }}>Skype</span>
                il convient également de mentionner que
                l'installation de l'application
                <span style={{ backgroundColor: "#00c82f00" }}>AnyDesk</span>
                sur le système du demandeur est nécessaire si le spécialiste le juge approprié.

                <br />
                <br />
                <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
            </div>

        ],
        "ja": [
            null,
            (props) => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>

                1- この製品は<span style={{ backgroundColor: "#00c82f00" }}> &nbsp;正しい動作</span> の{props.days.toLocaleString(z.lang.region)}日間の保証対象です。

                <br />
                <br />

                2- 保証期間中に<span style={{ backgroundColor: "#f6921800" }}>&nbsp;何か問題が発生した場合、</span> <span style={{ backgroundColor: "#00c82f00" }}>
                    このサービスへのお支払いはあなたのアカウントに返金されます。
                </span>

                <br />
                <br />
                3- <span style={{ backgroundColor: "#00c82f00" }}>分析ツールや戦略ロボット</span>、および <span
                    style={{ backgroundColor: "#00c82f00" }}>取引コピー・システム</span> は、当社のシステムからのシグナルによって生成された場合に収益性を保証します。ただし、指定された期間内に収益性がない場合、<span style={{ backgroundColor: "#f6921800" }}>このサービスへのすべての入金は、お客様のアカウントに返金されます。</span>

                <br />
                <br />
                4- 他のサービス、例えば <span style={{ backgroundColor: "#00c82f00" }}>APIやアセンブリライブラリ、分析ツールなどのツールやソフトウェア</span> は、適切なパフォーマンス基準に基づいて保証されます。これらは、テキストやビデオで説明されている正しいパフォーマンス基準に準拠する必要があります。
                <span style={{ backgroundColor: "#f6921800" }}>最後に、ビジネスモデルやツールの使用方法に依存するツールの収益性は保証の対象外です。</span>




                <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
                <br />
                <br />
            </div>,
            //2:
            (props) => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>

                1- この製品は<span style={{ backgroundColor: "#00c82f00" }}> &nbsp;正しい動作</span> の{props.days.toLocaleString(z.lang.region)}日間の保証対象です。

                <br />
                <br />

                2- 保証期間中に、<span style={{ backgroundColor: "#f6921800" }}>  サービスに関する深刻で解決不可能な技術的な問題 </span>に遭遇した場合、<span style={{ backgroundColor: "#00c82f00" }}>
                    このサービスの支払金額はあなたのアカウントに返金されます。
                </span>

                <br />
                <br />
                3- <span style={{ backgroundColor: "#00c82f00" }}>分析ツールや戦略ロボット</span>、および <span
                    style={{ backgroundColor: "#00c82f00" }}>取引コピー・システム</span> は、当社のシステムからのシグナルによって生成された場合に収益性を保証します。ただし、指定された期間内に収益性がない場合、<span style={{ backgroundColor: "#f6921800" }}>このサービスへのすべての入金は、お客様のアカウントに返金されます。</span>

                <br />
                <br />
                4- 他のサービス、例えば <span style={{ backgroundColor: "#00c82f00" }}>APIやアセンブリライブラリ、分析ツールなどのツールやソフトウェア</span> は、適切なパフォーマンス基準に基づいて保証されます。これらは、テキストやビデオで説明されている正しいパフォーマンス基準に準拠する必要があります。
                <span style={{ backgroundColor: "#f6921800" }}>最後に、ビジネスモデルやツールの使用方法に依存するツールの収益性は保証の対象外です。</span>




                <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
                <br />
                <br />
            </div>,
            //3:
            props => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>
                <span style={{ backgroundColor: "#00c82f00" }}> 1- この製品は、{props.days.toLocaleString(z.lang.region)}日間のコンサルテーションとガイダンスの保証が付いています。</span>
                <br />
                <br />

                <span style={{ backgroundColor: "#00c82f00" }}>
                    2- 保証期間中、提供されたサービスの分野に関連する専門家によるガイダンスが提供され、
                    それに関連するすべての質問と曖昧さは、関連する分野の専門家との直接の連絡によって解決されます。
                </span>


                <br />
                <br />
                <span style={{ backgroundColor: "#00c82f00" }}> 3- コンサルテーションの保証には、サービスエリアでのガイダンスと明確化が含まれています
                </span>


                <span style={{ backgroundColor: "#f6921800" }}>
                    そしてその実施は他の
                    さまざまなエリアでは基準ではありません
                </span>


                <span style={{ backgroundColor: "#00c82f00" }}>
                    しかし、サポートは、彼の問題を解決するために、可能な限りバイヤーを助けます。
                </span>

                <br />
                <br />
                <span style={{ backgroundColor: "#f6921800" }}>
                    4- 保証には、追加のコーディング、さまざまなプロジェクトの実施、または試験セッションへの参加は含まれていません
                </span>
                <br />
                <br />


                5- 保証は、集団通信ツールを介した通信によって実施されます。これには、
                <span style={{ backgroundColor: "#00c82f00" }}>Telegram</span>
                、
                <span style={{ backgroundColor: "#00c82f00" }}>Google Meet</span>
                および
                <span style={{ backgroundColor: "#00c82f00" }}>Skype</span>
                が含まれます。また、専門家が適切と判断した場合、申請者のシステムに
                <span style={{ backgroundColor: "#00c82f00" }}>AnyDesk</span>
                アプリケーションをインストールすることが必要であることにも言及する価値があります。

                <br />
                <br />
                <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
            </div>
        ],
        "ko": [
            null,
            (props) => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>

                1- 이 제품은 <span style={{ backgroundColor: "#00c82f00" }}> &nbsp;올바른 작동</span> 을 위한 {props.days.toLocaleString(z.lang.region)}일 보증이 적용됩니다.

                <br />
                <br />

                2- 보증 기간 동안 <span style={{ backgroundColor: "#f6921800" }}>&nbsp;어떤 문제가 발생하면,</span> <span style={{ backgroundColor: "#00c82f00" }}>
                    이 서비스에 대한 결제 금액이 당신의 계정으로 환불됩니다.
                </span>

                <br />
                <br />

                3- <span style={{ backgroundColor: "#00c82f00" }}>분석 도구와 전략 로봇</span> 및 <span
                    style={{ backgroundColor: "#00c82f00" }}>거래 복사 시스템</span>은 우리 시스템에서 생성된 신호에 따라 수익성을 보장합니다. 그러나 지정된 시간 내에 수익성이 없는 경우, <span style={{ backgroundColor: "#f6921800" }}>이 서비스에 대한 모든 입금은 귀하의 계정으로 환불됩니다.</span>

                <br />
                <br />

                4- 다른 서비스들은 <span style={{ backgroundColor: "#00c82f00" }}>API, 어셈블리 라이브러리, 분석 도구 등과 같은 도구와 소프트웨어</span>는 적절한 성능 기준에 따라 보장됩니다. 이들은 텍스트나 비디오에서 설명된 올바른 성능 기준을 준수해야 합니다.
                <span style={{ backgroundColor: "#f6921800" }}>마지막으로, 비즈니스 모델과 도구 사용 방식에 따라 수익성이 보장되지 않습니다.</span>

                <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
                <br />
                <br />
            </div>,
            (props) => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>

                1- 이 제품은 <span style={{ backgroundColor: "#00c82f00" }}> &nbsp;올바른 작동</span> 을 위한 {props.days.toLocaleString(z.lang.region)}일 보증이 적용됩니다.

                <br />
                <br />

                2- 보증 기간 동안 <span style={{ backgroundColor: "#f6921800" }}>  서비스와 관련된 심각하고 해결 불가능한 기술적 문제 </span>가 발생하는 경우, <span style={{ backgroundColor: "#00c82f00" }}>
                    이 서비스의 결제 금액이 계정으로 환불됩니다.
                </span>

                <br />
                <br />

                3- <span style={{ backgroundColor: "#00c82f00" }}>분석 도구와 전략 로봇</span> 및 <span
                    style={{ backgroundColor: "#00c82f00" }}>거래 복사 시스템</span>은 우리 시스템에서 생성된 신호에 따라 수익성을 보장합니다. 그러나 지정된 시간 내에 수익성이 없는 경우, <span style={{ backgroundColor: "#f6921800" }}>이 서비스에 대한 모든 입금은 귀하의 계정으로 환불됩니다.</span>

                <br />
                <br />

                4- 다른 서비스들은 <span style={{ backgroundColor: "#00c82f00" }}>API, 어셈블리 라이브러리, 분석 도구 등과 같은 도구와 소프트웨어</span>는 적절한 성능 기준에 따라 보장됩니다. 이들은 텍스트나 비디오에서 설명된 올바른 성능 기준을 준수해야 합니다.
                <span style={{ backgroundColor: "#f6921800" }}>마지막으로, 비즈니스 모델과 도구 사용 방식에 따라 수익성이 보장되지 않습니다.</span>

                <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
                <br />
                <br />
            </div>,
            //3:
            props => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>
                <span style={{ backgroundColor: "#00c82f00" }}> 1- 이 제품은 {props.days.toLocaleString(z.lang.region)}일의 컨설팅 및 지도 보증이 포함되어 있습니다.</span>
                <br />
                <br />

                <span style={{ backgroundColor: "#00c82f00" }}>
                    2- 보증 기간 동안 제공된 서비스 분야의 관련 전문가에 의한 지도가 제공되며,
                    이와 관련된 모든 질문과 모호성은 관련 분야의 전문가와의 직접적인 연락을 통해 해결됩니다.
                </span>


                <br />
                <br />
                <span style={{ backgroundColor: "#00c82f00" }}> 3- 컨설팅 보증은 서비스 영역에서의 지도 및 명확화를 포함합니다
                </span>


                <span style={{ backgroundColor: "#f6921800" }}>
                    그리고 그것의 구현은 다른
                    다양한 영역에서는 기준이 아닙니다
                </span>


                <span style={{ backgroundColor: "#00c82f00" }}>
                    그러나 지원은 그의 문제를 해결하기 위해 구매자를 최대한 돕습니다.
                </span>

                <br />
                <br />
                <span style={{ backgroundColor: "#f6921800" }}>
                    4- 보증에는 추가 코딩, 다양한 프로젝트의 수행, 또는 시험 세션에 참여하는 것이 포함되지 않습니다
                </span>
                <br />
                <br />


                5- 보증은 집단 통신 도구를 통한 통신을 통해 이루어집니다. 이에는
                <span style={{ backgroundColor: "#00c82f00" }}>Telegram</span>
                ,
                <span style={{ backgroundColor: "#00c82f00" }}>Google Meet</span>
                그리고
                <span style={{ backgroundColor: "#00c82f00" }}>Skype</span>
                가 포함됩니다. 또한 전문가가 적절하다고 판단하는 경우, 신청자의 시스템에
                <span style={{ backgroundColor: "#00c82f00" }}>AnyDesk</span>
                애플리케이션을 설치하는 것이 필요하다는 것도 언급할 가치가 있습니다.

                <br />
                <br />
                <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
            </div>


        ],
        "in": [
            null,
            (props) => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>

                1- Produk ini dilindungi oleh jaminan {props.days.toLocaleString(z.lang.region)} hari untuk <span style={{ backgroundColor: "#00c82f00" }}> &nbsp;operasi yang benar</span>.
                <br />
                <br />
                2- Jika Anda mengalami <span style={{ backgroundColor: "#f6921800" }}>&nbsp;masalah apa pun&nbsp;</span> dengan layanan selama periode garansi, <span style={{ backgroundColor: "#00c82f00" }}>
                    pembayaran untuk layanan ini akan dikembalikan ke akun Anda.
                </span>
                <br />
                <br />

                3-Harap diperhatikan bahwa <span style={{ backgroundColor: "#00c82f00" }}>alat analisis dan robot strategis</span> serta <span
                    style={{ backgroundColor: "#00c82f00" }}>sistem penyalin transaksi</span> menjamin keuntungan jika sinyalnya dihasilkan oleh sistem kami. Namun, jika tidak menguntungkan dalam waktu yang ditentukan, <span style={{ backgroundColor: "#f6921800" }}>semua deposit Anda untuk layanan ini akan dikembalikan ke akun Anda.</span>

                <br />
                <br />
                4- Layanan-layanan lain seperti <span style={{ backgroundColor: "#00c82f00" }}>alat-alat dan perangkat lunak seperti API, perpustakaan perakitan, dan alat analisis, dll.</span> dijamin berdasarkan kriteria kinerja yang tepat. Mereka harus sesuai dengan kriteria kinerja yang benar yang dijelaskan dalam teks atau video pada layanan Explore.
                <span style={{ backgroundColor: "#f6921800" }}>Akhirnya, profitabilitas alat-alat yang bergantung pada model bisnis Anda dan cara penggunaan alat-alat tersebut tidak termasuk dalam jaminan.</span>


                <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
                <br />
                <br />
            </div>,
            //2:
            (props) => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>

                1- Produk ini dilindungi oleh jaminan {props.days.toLocaleString(z.lang.region)} hari untuk <span style={{ backgroundColor: "#00c82f00" }}> &nbsp;operasi yang benar</span>.
                <br />
                <br />
                2- Selama periode garansi, jika Anda menghadapi masalah teknis <span style={{ backgroundColor: "#f6921800" }}>&nbsp; serius dan tidak dapat diatasi&nbsp;</span> mengenai layanan, <span style={{ backgroundColor: "#00c82f00" }}>
                    jumlah pembayaran untuk layanan ini akan dikembalikan ke akun Anda.
                </span>

                3-Harap diperhatikan bahwa <span style={{ backgroundColor: "#00c82f00" }}>alat analisis dan robot strategis</span> serta <span
                    style={{ backgroundColor: "#00c82f00" }}>sistem penyalin transaksi</span> menjamin keuntungan jika sinyalnya dihasilkan oleh sistem kami. Namun, jika tidak menguntungkan dalam waktu yang ditentukan, <span style={{ backgroundColor: "#f6921800" }}>semua deposit Anda untuk layanan ini akan dikembalikan ke akun Anda.</span>

                <br />
                <br />
                4- Layanan-layanan lain seperti <span style={{ backgroundColor: "#00c82f00" }}>alat-alat dan perangkat lunak seperti API, perpustakaan perakitan, dan alat analisis, dll.</span> dijamin berdasarkan kriteria kinerja yang tepat. Mereka harus sesuai dengan kriteria kinerja yang benar yang dijelaskan dalam teks atau video pada layanan Explore.
                <span style={{ backgroundColor: "#f6921800" }}>Akhirnya, profitabilitas alat-alat yang bergantung pada model bisnis Anda dan cara penggunaan alat-alat tersebut tidak termasuk dalam jaminan.</span>


                <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
                <br />
                <br />
            </div>,
            //3:
            props => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>
                <span style={{ backgroundColor: "#00c82f00" }}> 1- Produk ini dilengkapi dengan jaminan konsultasi dan bimbingan selama {props.days.toLocaleString(z.lang.region)} hari.</span>
                <br />
                <br />

                <span style={{ backgroundColor: "#00c82f00" }}>
                    2- Selama periode garansi, bimbingan disediakan oleh spesialis yang relevan di bidang layanan yang diberikan, dan
                    semua pertanyaan dan keambiguan yang terkait dengannya akan diselesaikan melalui kontak langsung dengan spesialis di bidang yang relevan.
                </span>


                <br />
                <br />
                <span style={{ backgroundColor: "#00c82f00" }}> 3- Jaminan konsultasi mencakup bimbingan dan klarifikasi di area layanan
                </span>


                <span style={{ backgroundColor: "#f6921800" }}>
                    dan implementasinya di lain
                    area yang beragam bukanlah kriteria
                </span>


                <span style={{ backgroundColor: "#00c82f00" }}>
                    namun, dukungan akan membantu pembeli sebanyak mungkin untuk menyelesaikan masalahnya.
                </span>

                <br />
                <br />
                <span style={{ backgroundColor: "#f6921800" }}>
                    4- Garansi tidak mencakup penulisan kode tambahan, pelaksanaan proyek yang beragam, atau partisipasi dalam sesi ujian
                </span>
                <br />
                <br />


                5- Garansi dilakukan melalui komunikasi melalui alat komunikasi kolektif seperti
                <span style={{ backgroundColor: "#00c82f00" }}>Telegram</span>
                ,
                <span style={{ backgroundColor: "#00c82f00" }}>Google Meet</span>
                dan
                <span style={{ backgroundColor: "#00c82f00" }}>Skype</span>
                juga layak disebutkan bahwa
                instalasi aplikasi
                <span style={{ backgroundColor: "#00c82f00" }}>AnyDesk</span>
                pada sistem pemohon diperlukan jika spesialis menganggapnya tepat.

                <br />
                <br />
                <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
            </div>


        ],
        "ru": [
            null,
            (props) => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>

                1- Этот продукт обеспечивается гарантией на {props.days.toLocaleString(z.lang.region)} дней для <span style={{ backgroundColor: "#00c82f00" }}> &nbsp;правильной работы</span>.
                <br />
                <br />
                2- Если возникнут <span style={{ backgroundColor: "#f6921800" }}>&nbsp;какие-либо проблемы&nbsp;</span> с услугой в течение периода гарантии, <span style={{ backgroundColor: "#00c82f00" }}>
                    ваш платеж за эту услугу будет возвращен на ваш счет.
                </span>
                <br />
                <br />

                3-Пожалуйста, обратите внимание, что <span style={{ backgroundColor: "#00c82f00" }}>аналитические инструменты и стратегические роботы</span> и <span
                    style={{ backgroundColor: "#00c82f00" }}>системы копирования сделок</span> гарантируют прибыльность, если их сигналы генерируются нашей системой. Однако, если они не приносят прибыль в указанный срок, <span style={{ backgroundColor: "#f6921800" }}>все ваши взносы за эту услугу будут возвращены на ваш счет.</span>

                <br />
                <br />
                4- Другие услуги, такие как <span style={{ backgroundColor: "#00c82f00" }}>инструменты и программное обеспечение, такие как API, сборочные библиотеки, аналитические инструменты и т. д.</span>, гарантируются в соответствии с правильными критериями производительности. Они должны соответствовать правильным критериям производительности, описанным в тексте или видео в сервисе Explore.
                <span style={{ backgroundColor: "#f6921800" }}>Наконец, прибыльность инструментов, которая зависит от вашей бизнес-модели и способа использования инструментов, не покрывается гарантией.</span>


                <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
                <br />
                <br />
            </div>,
            //2:
            (props) => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>

                1- Этот продукт обеспечивается гарантией на {props.days.toLocaleString(z.lang.region)} дней для <span style={{ backgroundColor: "#00c82f00" }}> &nbsp;правильной работы</span>.
                <br />
                <br />
                2- В течение гарантийного периода, если вы столкнетесь с <span style={{ backgroundColor: "#f6921800" }}>&nbsp; серьезной и неразрешимой технической проблемой&nbsp;</span> касательно услуги, <span style={{ backgroundColor: "#00c82f00" }}>
                    сумма оплаты за данную услугу будет возвращена на ваш счет.
                </span>
                <br />
                <br />

                3-Пожалуйста, обратите внимание, что <span style={{ backgroundColor: "#00c82f00" }}>аналитические инструменты и стратегические роботы</span> и <span
                    style={{ backgroundColor: "#00c82f00" }}>системы копирования сделок</span> гарантируют прибыльность, если их сигналы генерируются нашей системой. Однако, если они не приносят прибыль в указанный срок, <span style={{ backgroundColor: "#f6921800" }}>все ваши взносы за эту услугу будут возвращены на ваш счет.</span>

                <br />
                <br />
                4- Другие услуги, такие как <span style={{ backgroundColor: "#00c82f00" }}>инструменты и программное обеспечение, такие как API, сборочные библиотеки, аналитические инструменты и т. д.</span>, гарантируются в соответствии с правильными критериями производительности. Они должны соответствовать правильным критериям производительности, описанным в тексте или видео в сервисе Explore.
                <span style={{ backgroundColor: "#f6921800" }}>Наконец, прибыльность инструментов, которая зависит от вашей бизнес-модели и способа использования инструментов, не покрывается гарантией.</span>


                <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
                <br />
                <br />
            </div>,
            //3:
            props => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>
                <span style={{ backgroundColor: "#00c82f00" }}> 1- Этот продукт поставляется с гарантией консультаций и руководства на {props.days.toLocaleString(z.lang.region)} дней.</span>
                <br />
                <br />

                <span style={{ backgroundColor: "#00c82f00" }}>
                    2- В течение гарантийного периода консультации проводятся специалистами, связанными с предоставляемыми услугами, и
                    все вопросы и неясности, связанные с этим, будут решены через прямой контакт со специалистом в соответствующей области.
                </span>


                <br />
                <br />
                <span style={{ backgroundColor: "#00c82f00" }}> 3- Гарантия консультаций включает руководство и разъяснения в области услуг
                </span>


                <span style={{ backgroundColor: "#f6921800" }}>
                    и ее реализация в других
                    различных областях не является критерием
                </span>


                <span style={{ backgroundColor: "#00c82f00" }}>
                    однако поддержка поможет покупателю максимально возможным образом решить его проблему.
                </span>

                <br />
                <br />
                <span style={{ backgroundColor: "#f6921800" }}>
                    4- Гарантия не включает дополнительное кодирование, выполнение различных проектов или участие в экзаменационных сессиях
                </span>
                <br />
                <br />


                5- Гарантия осуществляется через общение с помощью коллективных средств связи, таких как
                <span style={{ backgroundColor: "#00c82f00" }}>Telegram</span>
                ,
                <span style={{ backgroundColor: "#00c82f00" }}>Google Meet</span>
                и
                <span style={{ backgroundColor: "#00c82f00" }}>Skype</span>
                также стоит отметить, что
                установка приложения
                <span style={{ backgroundColor: "#00c82f00" }}>AnyDesk</span>
                на систему заявителя необходима, если специалист считает это целесообразным.

                <br />
                <br />
                <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
            </div>

        ],

        "pt": [
            null,
            (props) => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>

                1- Este produto está coberto por uma garantia de {props.days.toLocaleString(z.lang.region)} dias para <span style={{ backgroundColor: "#00c82f00" }}> &nbsp;funcionamento correto</span>.
                <br />
                <br />
                2- Durante o período de garantia, se você encontrar um problema técnico <span style={{ backgroundColor: "#f6921800" }}>&nbsp; grave e insolúvel&nbsp;</span> em relação ao serviço, <span style={{ backgroundColor: "#00c82f00" }}>
                    o valor do pagamento por este serviço será reembolsado para a sua conta.
                </span>
                <br />
                <br />

                3-Por favor, observe que <span style={{ backgroundColor: "#00c82f00" }}>ferramentas analíticas e robôs estrategistas</span> e <span
                    style={{ backgroundColor: "#00c82f00" }}>sistemas de cópia de negociações</span> garantem lucratividade se os sinais forem gerados pelo nosso sistema. No entanto, se não forem lucrativos dentro do prazo especificado, <span style={{ backgroundColor: "#f6921800" }}>todos os seus depósitos para este serviço serão reembolsados em sua conta.</span>
                <br />
                <br />

                4- Outros serviços, como <span style={{ backgroundColor: "#00c82f00" }}>ferramentas e software como APIs, bibliotecas de montagem e ferramentas de análise, etc.</span>, são garantidos com base em critérios de desempenho adequados. Eles devem estar em conformidade com os critérios corretos de desempenho descritos no texto ou vídeos do serviço Explore.
                <span style={{ backgroundColor: "#f6921800" }}>Por fim, a rentabilidade de ferramentas que dependem do seu modelo de negócio e da forma como as ferramentas são utilizadas não está coberta pela garantia.</span>


                <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
                <br />
                <br />
            </div>,

            //2:
            (props) => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>

                1- Este produto está coberto por uma garantia de {props.days.toLocaleString(z.lang.region)} dias para <span style={{ backgroundColor: "#00c82f00" }}> &nbsp;funcionamento correto</span>.
                <br />
                <br />
                2- Se você encontrar <span style={{ backgroundColor: "#f6921800" }}>&nbsp;qualquer problema&nbsp;</span> com o serviço durante o período de garantia, <span style={{ backgroundColor: "#00c82f00" }}>
                    o pagamento pelo serviço será reembolsado na sua conta.
                </span>
                <br />
                <br />

                3-Por favor, observe que <span style={{ backgroundColor: "#00c82f00" }}>ferramentas analíticas e robôs estrategistas</span> e <span
                    style={{ backgroundColor: "#00c82f00" }}>sistemas de cópia de negociações</span> garantem lucratividade se os sinais forem gerados pelo nosso sistema. No entanto, se não forem lucrativos dentro do prazo especificado, <span style={{ backgroundColor: "#f6921800" }}>todos os seus depósitos para este serviço serão reembolsados em sua conta.</span>
                <br />
                <br />

                4- Outros serviços, como <span style={{ backgroundColor: "#00c82f00" }}>ferramentas e software como APIs, bibliotecas de montagem e ferramentas de análise, etc.</span>, são garantidos com base em critérios de desempenho adequados. Eles devem estar em conformidade com os critérios corretos de desempenho descritos no texto ou vídeos do serviço Explore.
                <span style={{ backgroundColor: "#f6921800" }}>Por fim, a rentabilidade de ferramentas que dependem do seu modelo de negócio e da forma como as ferramentas são utilizadas não está coberta pela garantia.</span>


                <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
                <br />
                <br />
            </div>,

            //3:
            props => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>
                <span style={{ backgroundColor: "#00c82f00" }}> 1- Este produto vem com uma garantia de consulta e orientação de {props.days.toLocaleString(z.lang.region)} dias.</span>
                <br />
                <br />

                <span style={{ backgroundColor: "#00c82f00" }}>
                    2- Durante o período de garantia, a orientação é fornecida por especialistas relevantes na área de serviços prestados, e
                    todas as perguntas e ambiguidades relacionadas serão resolvidas através do contato direto com o especialista na área relevante.
                </span>


                <br />
                <br />
                <span style={{ backgroundColor: "#00c82f00" }}> 3- A garantia de consulta inclui orientação e esclarecimento na área de serviço
                </span>


                <span style={{ backgroundColor: "#f6921800" }}>
                    e sua implementação em outras
                    áreas diversas não é um critério
                </span>


                <span style={{ backgroundColor: "#00c82f00" }}>
                    no entanto, o suporte ajudará o comprador tanto quanto possível para resolver seu problema.
                </span>

                <br />
                <br />
                <span style={{ backgroundColor: "#f6921800" }}>
                    4- A garantia não inclui codificação adicional, realização de projetos diversos ou participação em sessões de exame
                </span>
                <br />
                <br />


                5- A garantia é realizada através da comunicação através de ferramentas de comunicação coletiva, como
                <span style={{ backgroundColor: "#00c82f00" }}>Telegram</span>
                ,
                <span style={{ backgroundColor: "#00c82f00" }}>Google Meet</span>
                e
                <span style={{ backgroundColor: "#00c82f00" }}>Skype</span>
                também vale a pena mencionar que
                a instalação do aplicativo
                <span style={{ backgroundColor: "#00c82f00" }}>AnyDesk</span>
                no sistema do requerente é necessária se o especialista considerar apropriado.

                <br />
                <br />
                <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
            </div>


        ],

        "tr":
            [
                null,
                (props) => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>
                    1- Bu ürün, <span style={{ backgroundColor: "#00c82f00" }}>  doğru işlem</span> garantisi olan {props.days.toLocaleString(z.lang.region)} günlük bir garantisi vardır.
                    <br />
                    <br />
                    2- Garanti süresi boyunca, hizmetle ilgili olarak <span style={{ backgroundColor: "#f6921800" }}>  ciddi ve çözülemez bir teknik sorun </span> ile karşılaşırsanız, <span style={{ backgroundColor: "#00c82f00" }}>
                        bu hizmet için ödeme miktarı hesabınıza iade edilecektir.
                    </span>
                    <br />
                    <br />
                    3- Lütfen not edin ki, <span style={{ backgroundColor: "#00c82f00" }}>Otomatik Ticaret Robotları</span> ve <span
                        style={{ backgroundColor: "#00c82f00" }}>Kopya Ticaret sistemleri</span> sistemimizden sinyalleri verilmiş olanlar, doğru işlemi
                    karlılıkla ilgilidir ve eğer <span style={{ backgroundColor: "#f6921800" }}>garanti süresi boyunca karlı değillerse</span>, <span
                        style={{ backgroundColor: "#00c82f00" }}>bu ürün için bize yatırdığınız tüm depozito ücreti iade edilecektir.</span>
                    <br />
                    <br />
                    4- Diğer <span style={{ backgroundColor: "#00c82f00" }}>araçlar ve yazılımlar gibi DLL'ler, scriptler, scrappers, veri kaynakları</span>
                    ve '3' numaralı paragraftan başka her şeyin garantisi, belgelerinde açıklanan
                    <span style={{ backgroundColor: "#00c82f00" }}>işlem yeteneği ve doğruluğu</span> ile ilgilidir ve <span
                        style={{ backgroundColor: "#f6921800" }}>hiçbir ilgisi yoktur</span> <span style={{ backgroundColor: "#f6921800" }}>ticaret sisteminizin veya işletmenizin kullanım şekli ve kar veya zararı ile.</span>.
                    <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
                    <br />
                    <br />
                </div>
                ,
                //2:
                (props) => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>
                    1- Bu ürün, <span style={{ backgroundColor: "#00c82f00" }}>  doğru işlem</span> garantisi olan {props.days.toLocaleString(z.lang.region)} günlük bir garantisi vardır.
                    <br />
                    <br />
                    2- Garanti süresi boyunca, hizmetle ilgili olarak <span style={{ backgroundColor: "#f6921800" }}>  ciddi ve çözülemez bir teknik sorun </span> ile karşılaşırsanız, <span style={{ backgroundColor: "#00c82f00" }}>
                        bu hizmet için ödeme miktarı hesabınıza iade edilecektir.
                    </span>
                    <br />
                    <br />
                    3- Lütfen not edin ki, <span style={{ backgroundColor: "#00c82f00" }}>Otomatik Ticaret Robotları</span> ve <span
                        style={{ backgroundColor: "#00c82f00" }}>Kopya Ticaret sistemleri</span> sistemimizden sinyalleri verilmiş olanlar, doğru işlemi
                    karlılıkla ilgilidir ve eğer <span style={{ backgroundColor: "#f6921800" }}>garanti süresi boyunca karlı değillerse</span>, <span
                        style={{ backgroundColor: "#00c82f00" }}>bu ürün için bize yatırdığınız tüm depozito ücreti iade edilecektir.</span>
                    <br />
                    <br />
                    4- Diğer <span style={{ backgroundColor: "#00c82f00" }}>araçlar ve yazılımlar gibi DLL'ler, scriptler, scrappers, veri kaynakları</span>
                    ve '3' numaralı paragraftan başka her şeyin garantisi, belgelerinde açıklanan
                    <span style={{ backgroundColor: "#00c82f00" }}>işlem yeteneği ve doğruluğu</span> ile ilgilidir ve <span
                        style={{ backgroundColor: "#f6921800" }}>hiçbir ilgisi yoktur</span> <span style={{ backgroundColor: "#f6921800" }}>ticaret sisteminizin veya işletmenizin kullanım şekli ve kar veya zararı ile.</span>.
                    <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
                    <br />
                    <br />
                </div>
                ,
                //3:

                props => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>
                    <span style={{ backgroundColor: "#00c82f00" }}> 1- Bu ürün, {props.days.toLocaleString(z.lang.region)} günlük danışmanlık ve rehberlik garantisi ile birlikte gelir.</span>
                    <br />
                    <br />

                    <span style={{ backgroundColor: "#00c82f00" }}>
                        2- Garanti süresi boyunca, hizmetlerin sunulduğu alanda ilgili uzmanlar tarafından rehberlik sağlanır ve
                        bununla ilgili tüm sorular ve belirsizlikler, ilgili alandaki uzmanla doğrudan iletişim kurarak çözülür.
                    </span>


                    <br />
                    <br />
                    <span style={{ backgroundColor: "#00c82f00" }}> 3- Danışmanlık garantisi, hizmet alanında rehberlik ve açıklama içerir
                    </span>


                    <span style={{ backgroundColor: "#f6921800" }}>
                        ve onun uygulanması diğer
                        çeşitli alanlarda bir kriter değildir
                    </span>


                    <span style={{ backgroundColor: "#00c82f00" }}>
                        ancak yine de destek, müşterinin sorununu çözmek için mümkün olduğunca yardımcı olacaktır.
                    </span>

                    <br />
                    <br />
                    <span style={{ backgroundColor: "#f6921800" }}>
                        4- Garanti, ek kodlama, çeşitli projelerin gerçekleştirilmesi veya sınav oturumlarına katılmayı içermez
                    </span>
                    <br />
                    <br />


                    5- Garanti,
                    <span style={{ backgroundColor: "#00c82f00" }}>Telegram</span>
                    ,
                    <span style={{ backgroundColor: "#00c82f00" }}>Google Meet</span>
                    ve
                    <span style={{ backgroundColor: "#00c82f00" }}>Skype</span>
                    gibi toplu iletişim araçları aracılığıyla iletişim kurularak gerçekleştirilir. Ayrıca, uzmanın uygun görmesi durumunda, başvuru sahibinin sistemine
                    <span style={{ backgroundColor: "#00c82f00" }}>AnyDesk</span>
                    uygulamasının kurulması gerektiğini belirtmek de önemlidir.

                    <br />
                    <br />
                    <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
                </div>

            ],

        "ur": [
            null,
            (props) => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>

                1- اس مصنوعات کو <span style={{ backgroundColor: "#00c82f00" }}> &nbsp;صحیح عملکری</span> کی {props.days.toLocaleString(z.lang.region)} دن کی گارنٹی فراہم کی گئی ہے۔

                <br />
                <br />
                2- اگر آپ کو گارانٹی کی مدت میں <span style={{ backgroundColor: "#f6921800" }}>&nbsp;کسی بھی مسئلے کا سامنا کرنا پڑے</span> تو، <span style={{ backgroundColor: "#00c82f00" }}>
                    آپ کی اس خدمت کی فیس آپ کے اکاؤنٹ میں واپس کی جائے گی۔
                </span>

                <br />
                <br />

                3- براہ کرم نوٹ کریں کہ <span style={{ backgroundColor: "#00c82f00" }}>تجزیاتی اوزار اور روبوٹ استراتیجیست</span> اور <span
                    style={{ backgroundColor: "#00c82f00" }}>کاپی ٹریڈنگ سسٹمز</span> منتقلی کی صورت میں منافع کی ضمانت دیتے ہیں اگر ان کی سگنلز ہمارے سسٹم سے جاری کی جائیں. لیکن اگر مقررہ وقت میں منافع نہ ہوں تو <span style={{ backgroundColor: "#f6921800" }}>اس خدمت کے لئے آپ کے تمام جمع کروائیاں آپ کے اکاؤنٹ میں واپس کر دی جائیں گی۔</span>

                <br />
                <br />

                4- دیگر خدمات جیسے <span style={{ backgroundColor: "#00c82f00" }}>APIs، اسمبلی لائبریریز، تجزیہ اوزار و غیرہ</span> کی طرح <span style={{ backgroundColor: "#00c82f00" }}>ٹولز اور سافٹ ویئر</span> کو بھی مناسب کارکردگی کے معیاروں کے مطابق گارنٹی دی جاتی ہیں۔ یہی معیارات درست کارکردگی کے متن یا ویڈیوز میں بیان کیے گئے معیارات کے مطابق ہونے چاہئیں۔
                <span style={{ backgroundColor: "#f6921800" }}>آخر کار، آپ کے بزنس ماڈل اور ٹولز کے استعمال کے طریقے پر منحصر ہونے والے ٹولز کی منافع گارنٹی کے تحت نہیں ہوتیں۔</span>



                <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
                <br />
                <br />
            </div>,
            //2:
            (props) => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>

                1- اس مصنوعات کو <span style={{ backgroundColor: "#00c82f00" }}> &nbsp;صحیح عملکری</span> کی {props.days.toLocaleString(z.lang.region)} دن کی گارنٹی فراہم کی گئی ہے۔

                <br />
                <br />
                2- وارنٹی کی مدت کے دوران، اگر آپ کو خدمت کے متعلق <span style={{ backgroundColor: "#f6921800" }}>  سنگین اور حل ناشدہ تکنیکی مسئلہ </span> کا سامنا کرنا پڑے، <span style={{ backgroundColor: "#00c82f00" }}>
                    آپ کے اکاؤنٹ میں اس خدمت کے لئے کی گئی ادائیگی کی رقم واپس کی جائے گی۔
                </span>

                <br />
                <br />

                3- براہ کرم نوٹ کریں کہ <span style={{ backgroundColor: "#00c82f00" }}>تجزیاتی اوزار اور روبوٹ استراتیجیست</span> اور <span
                    style={{ backgroundColor: "#00c82f00" }}>کاپی ٹریڈنگ سسٹمز</span> منتقلی کی صورت میں منافع کی ضمانت دیتے ہیں اگر ان کی سگنلز ہمارے سسٹم سے جاری کی جائیں. لیکن اگر مقررہ وقت میں منافع نہ ہوں تو <span style={{ backgroundColor: "#f6921800" }}>اس خدمت کے لئے آپ کے تمام جمع کروائیاں آپ کے اکاؤنٹ میں واپس کر دی جائیں گی۔</span>

                <br />
                <br />

                4- دیگر خدمات جیسے <span style={{ backgroundColor: "#00c82f00" }}>APIs، اسمبلی لائبریریز، تجزیہ اوزار و غیرہ</span> کی طرح <span style={{ backgroundColor: "#00c82f00" }}>ٹولز اور سافٹ ویئر</span> کو بھی مناسب کارکردگی کے معیاروں کے مطابق گارنٹی دی جاتی ہیں۔ یہی معیارات درست کارکردگی کے متن یا ویڈیوز میں بیان کیے گئے معیارات کے مطابق ہونے چاہئیں۔
                <span style={{ backgroundColor: "#f6921800" }}>آخر کار، آپ کے بزنس ماڈل اور ٹولز کے استعمال کے طریقے پر منحصر ہونے والے ٹولز کی منافع گارنٹی کے تحت نہیں ہوتیں۔</span>



                <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
                <br />
                <br />
            </div>,

            //3:
            props => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>
                <span style={{ backgroundColor: "#00c82f00" }}> 1- یہ مصنوعات {props.days.toLocaleString(z.lang.region)} دن کی مشاورت اور ہدایت کی ضمانت کے ساتھ آتی ہیں۔</span>
                <br />
                <br />

                <span style={{ backgroundColor: "#00c82f00" }}>
                    2- گارنٹی کی مدت کے دوران، متعلقہ ماہرین کی جانب سے فراہم کی گئی خدمات کے شعبے میں رہنمائی فراہم کی جاتی ہے، اور
                    اس سے متعلق تمام سوالات اور ابہامات متعلقہ شعبے کے ماہر سے براہ راست رابطے کے ذریعہ حل ہوں گے۔
                </span>


                <br />
                <br />
                <span style={{ backgroundColor: "#00c82f00" }}> 3- مشاورت کی ضمانت میں سروس کے علاقے میں رہنمائی اور وضاحت شامل ہوتی ہے
                </span>


                <span style={{ backgroundColor: "#f6921800" }}>
                    اور اس کی تنفیذ دیگر
                    مختلف علاقوں میں کوئی معیار نہیں ہے
                </span>


                <span style={{ backgroundColor: "#00c82f00" }}>
                    ہالانکہ، سپورٹ ، خریدار کو اپنی مشکل کو حل کرنے کے لئے جتنا ممکن ہو سکے مدد کرے گا۔
                </span>

                <br />
                <br />
                <span style={{ backgroundColor: "#f6921800" }}>
                    4- گارنٹی میں اضافی کوڈنگ، مختلف منصوبوں کی تنفیذ، یا امتحان کی سیشن میں شرکت کرنے کی شامل نہیں ہے
                </span>
                <br />
                <br />


                5- گارنٹی کو جماعتی مواصلاتی اوزار جیسے کہ
                <span style={{ backgroundColor: "#00c82f00" }}>ٹیلیگرام</span>
                ,
                <span style={{ backgroundColor: "#00c82f00" }}>گوگل میٹ</span>
                اور
                <span style={{ backgroundColor: "#00c82f00" }}>اسکائپ</span>
                کے ذریعے مواصلات کی جاتی ہے۔ یہ بھی ذکر کرنے کی قابلیت ہے کہ
                درخواست دہندہ کے سسٹم پر
                <span style={{ backgroundColor: "#00c82f00" }}>اینی ڈیسک</span>
                کی ایپلیکیشن کی تنصیب ضروری ہے اگر ماہر اسے مناسب سمجھتا ہے۔

                <br />
                <br />
                <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
            </div>

        ],

        "zh": [
            null,
            (props) => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>

                1- 本产品享有 {props.days.toLocaleString(z.lang.region)} 天的保修期，<span style={{ backgroundColor: "#00c82f00" }}> &nbsp;正常运行</span> 。

                <br />
                <br />

                2- 如果在保修期内<span style={{ backgroundColor: "#f6921800" }}>&nbsp;遇到任何问题，</span> <span style={{ backgroundColor: "#00c82f00" }}>
                    您支付的费用将退还到您的帐户。
                </span>

                <br />
                <br />

                3- 请注意，<span style={{ backgroundColor: "#00c82f00" }}>分析工具和策略机器人</span>以及<span
                    style={{ backgroundColor: "#00c82f00" }}>复制交易系统</span>只有在其信号由我们的系统生成时才能保证盈利。然而，如果在指定的时间内没有盈利，<span style={{ backgroundColor: "#f6921800" }}>您为此服务所做的所有存款将退还到您的账户。</span>

                <br />
                <br />

                4- 其他服务，如<span style={{ backgroundColor: "#00c82f00" }}>API、组装库、分析工具等工具和软件</span>，根据适当的性能标准进行保证。它们应符合文本或视频中描述的正确性能标准。
                <span style={{ backgroundColor: "#f6921800" }}>最后，依赖于您的业务模型和工具使用方式的工具的盈利能力不在保修范围内。</span>


                <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
                <br />
                <br />
            </div>,
            //2:

            (props) => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>

                1- 本产品享有 {props.days.toLocaleString(z.lang.region)} 天的保修期，<span style={{ backgroundColor: "#00c82f00" }}> &nbsp;正常运行</span> 。

                <br />
                <br />

                2- 保固期内，如果遇到 <span style={{ backgroundColor: "#f6921800" }}>&nbsp; 严重且无法解决的技术问题&nbsp;</span> 关于服务，<span style={{ backgroundColor: "#00c82f00" }}>
                    此服务的付款金额将退还到您的账户。
                </span>

                <br />
                <br />

                3- 请注意，<span style={{ backgroundColor: "#00c82f00" }}>分析工具和策略机器人</span>以及<span
                    style={{ backgroundColor: "#00c82f00" }}>复制交易系统</span>只有在其信号由我们的系统生成时才能保证盈利。然而，如果在指定的时间内没有盈利，<span style={{ backgroundColor: "#f6921800" }}>您为此服务所做的所有存款将退还到您的账户。</span>

                <br />
                <br />

                4- 其他服务，如<span style={{ backgroundColor: "#00c82f00" }}>API、组装库、分析工具等工具和软件</span>，根据适当的性能标准进行保证。它们应符合文本或视频中描述的正确性能标准。
                <span style={{ backgroundColor: "#f6921800" }}>最后，依赖于您的业务模型和工具使用方式的工具的盈利能力不在保修范围内。</span>


                <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
                <br />
                <br />
            </div>,

            //3:

            props => <div style={{ width: "100%", textAlign: "justify", lineHeight: 1.5, fontSize: 11, fontWeight: "500" }}>
                <span style={{ backgroundColor: "#00c82f00" }}> 1- 本产品附带 {props.days.toLocaleString(z.lang.region)} 天的咨询和指导保证。</span>
                <br />
                <br />

                <span style={{ backgroundColor: "#00c82f00" }}>
                    2- 在保证期间，相关专家在提供的服务领域提供指导，以及
                    与之相关的所有问题和模糊性将通过与相关领域的专家直接联系来解决。
                </span>


                <br />
                <br />
                <span style={{ backgroundColor: "#00c82f00" }}> 3- 咨询保证包括在服务领域的指导和澄清
                </span>


                <span style={{ backgroundColor: "#f6921800" }}>
                    并且其在其他
                    各种领域的实施并不是一个标准
                </span>


                <span style={{ backgroundColor: "#00c82f00" }}>
                    然而，支持将尽可能地帮助买家解决他的问题。
                </span>

                <br />
                <br />
                <span style={{ backgroundColor: "#f6921800" }}>
                    4- 保证不包括额外的编码，执行各种项目，或参加考试会议
                </span>
                <br />
                <br />


                5- 保证是通过集体通信工具进行通信的，如
                <span style={{ backgroundColor: "#00c82f00" }}>Telegram</span>
                ,
                <span style={{ backgroundColor: "#00c82f00" }}>Google Meet</span>
                和
                <span style={{ backgroundColor: "#00c82f00" }}>Skype</span>
                还值得一提的是
                在申请人的系统上安装
                <span style={{ backgroundColor: "#00c82f00" }}>AnyDesk</span>
                应用程序是必要的，如果专家认为这是适当的。

                <br />
                <br />
                <div style={{ zIndex: -1, width: "100%", height: "80%", left: 5, top: 40, bottom: 0, opacity: 0.3, position: "absolute", backgroundImage: `url(${cdn('/files/shield.svgx')})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", }}></div>
            </div>

        ],
    }
}